import { Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { User } from '../../models/user.model';
import { AlertService } from '../../util/alert/alert.service';
import { LocalStorage } from '../../util/localstorage.service';
import { UserDataService } from '../../admin/user/user-data.service';
import { DatePipe } from '@angular/common';
import { CommonFunctions } from '../../util/common-functions';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public loggedUser: User
  public user:User;
  public id
  public firstname
  public middlename
  public lastname
  public dob
  public email
  public phone
  public clinicid
  public userroleid
  public updateMode
  public deleteMode
  public name

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService,
    private userService: UserDataService) {}

  ngOnInit(): void {

    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
		if ((this.loggedUser != null) && (this.loggedUser != undefined)) {

        this.id = this.loggedUser.UserID
        this.clinicid = this.loggedUser.ClinicID
        this.firstname = this.loggedUser.FirstName
        this.middlename = this.loggedUser.MiddleName
        this.lastname = this.loggedUser.LastName
        var datePipe = new DatePipe('en-US');
        this.dob = datePipe.transform(this.loggedUser.DateOfBirth, 'MM/dd/yyyy');
        this.email = this.loggedUser.Email
        this.phone = this.loggedUser.Phone
        this.userroleid = this.loggedUser.UserRoleID

		} else {
			//Don't know the user, send to login.
			this.router.navigateByUrl('');
    }

    this.iSForm = this.formBuilder.group({
      name: new FormControl(null),
      firstname: new FormControl(null),
      middlename: new FormControl(null),
      lastname: new FormControl(null),
      dob: new FormControl(null),
      email: new FormControl(null),
      phone: new FormControl(null)
    } );

    this.loadData()
  }

  loadData()
	{
    this.alertService.clear()
    this.userService.getUserByID(this.loggedUser, this.id).subscribe(data => this.getData(data))
	}

  public getData(data: any) {
    this.user  = data
    if (this.user != null && this.user != undefined){
			localStorage.setItem(LocalStorage.LOGGED_USER, JSON.stringify(this.user));
    }
    this.clinicid = data.ClinicID
    this.firstname = data.FirstName
    this.middlename = data.MiddleName
    this.lastname = data.LastName
    var datePipe = new DatePipe('en-US');
    if(datePipe.transform(data.DateOfBirth, 'MM/dd/yyyy') != "01/01/0001"){
      this.dob = datePipe.transform(data.DateOfBirth, 'MM/dd/yyyy');
    } else{
      this.dob = "";
    }
    this.email = data.Email
    this.phone = data.Phone
    this.userroleid = data.UserRoleID
  }

  intializeUserDetails()
  {
    this.firstname = ""
    this.middlename = ""
    this.lastname = ""
    this.dob = ""
    this.email = ""
    this.phone = ""
  }

  onDateOfBirthChange(event){
    this.dob = event
  }

  cancelBtnClickEvent(){
    this.intializeUserDetails()
	  this.loadData()
  }


  // exitBtnClickEvent(){
  //   this.router.navigateByUrl('landing');
  // }

  validateUser():boolean
  {
        if ((this.iSForm.controls.firstname.value == ""  ||
        this.iSForm.controls.firstname.value == null ))
        {
          this.alertService.clear()
          this.alertService.error('Invalid First Name')
          return false
        }
        if ((this.iSForm.controls.lastname.value == ""  ||
              this.iSForm.controls.lastname.value == null ))
        {
          this.alertService.clear()
          this.alertService.error('Invalid Last Name')
          return false
        }
        if ((this.iSForm.controls.dob.value != "") && (this.iSForm.controls.dob.value != null) && (this.iSForm.controls.dob.value == "Invalid Date"))
        {
          this.alertService.clear()
          this.alertService.error('Invalid Date of Birth')
          return false
        }
        var phoneVal = /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/;
        if (this.iSForm.controls.phone.value != null && this.iSForm.controls.phone.value != "") {
          if(!(phoneVal.test(this.iSForm.controls.phone.value))){
            this.alertService.clear()
            this.alertService.error('Invalid Phone Number')
            return false
          }
        }
    return true
  }

  saveBtnClickEvent(){
    if (this.validateUser()){
      this.user = new User()
      this.user.UserID =  this.id
      this.user.ClinicID =  this.clinicid
      this.user.FirstName = this.firstname
      this.user.MiddleName =  this.middlename
      this.user.LastName = this.lastname
      if(this.iSForm.controls.dob.value != null && this.iSForm.controls.dob.value != ''){
        this.user.DateOfBirth = new Date(this.dob).toLocaleDateString()
      } else{
        this.user.DateOfBirth = null
      }
      this.user.Email = this.email
      this.user.Phone = this.phone
      this.user.UserRoleID =  Number(this.userroleid)
      this.user.bDeleted = false
      this.userService.saveUser(this.user, this.loggedUser).subscribe(date =>
      {
        this.alertService.clear()
        this.loadData()
        this.alertService.success('Successfully updated')
      },
      error => {
        this.alertService.clear()
        this.loadData()
        this.alertService.error('Error occured while saving data')

      });
    }
  }
}
